module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/leader-seminar/font/notokr-regular.woff
// module id = 3uxu
// module chunks = 0